(function () {
  function collectFormLineItemProperties(form) {
    var out = {};
    if (!form) return out;

    form
      .querySelectorAll(
        'input[name^="properties["], textarea[name^="properties["], select[name^="properties["]'
      )
      .forEach(function (el) {
        if (el.disabled) return;

        var name = el.name || '';
        var match = name.match(/^properties\[(.+)\]$/);
        if (!match) return;

        var key = match[1];
        if (el.value == null) return;

        out[key] = String(el.value);
      });

    return out;
  }

  function collectPairedItems() {
    var pairedItems = [];

    document.querySelectorAll('[data-paired-product-form]').forEach(function (form) {
      var variantInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('[data-paired-quantity-input]');

      var variantId = variantInput ? variantInput.value : null;
      var qty = qtyInput ? Number(qtyInput.value || 0) : 0;

      if (variantId && qty > 0) {
        pairedItems.push({
          id: Number(variantId),
          quantity: qty
        });
      }
    });

    return pairedItems;
  }

  function buildMainItem(mainForm) {
    var variantInput = mainForm.querySelector('[name="id"]');
    var qtyInput = mainForm.querySelector('[name="quantity"]');
    var properties = collectFormLineItemProperties(mainForm);

    return {
      id: Number(variantInput.value),
      quantity: qtyInput ? Number(qtyInput.value || 1) : 1,
      properties: properties
    };
  }

  function maybeAppendCustomDateCharge(items, properties) {
    var deliveryRoot = document.querySelector('[data-ats-delivery]');
    if (!deliveryRoot) return items;

    var chargeEnabled = deliveryRoot.dataset.customDateChargeEnabled === 'true';
    var chargeVariantId = Number(deliveryRoot.dataset.customDateChargeVariant || 0);

    if (properties['Delivery Type'] !== 'Custom' || !chargeEnabled || !chargeVariantId) {
      return items;
    }

    items.push({
      id: chargeVariantId,
      quantity: items[0].quantity,
      properties: {
        'Delivery Date': properties['Delivery Date'],
        'Delivery Type': 'Custom'
      }
    });

    return items;
  }

  if (!window.ATSComplementarySubmitReady) {
    window.ATSComplementarySubmitReady = true;

    document.addEventListener(
      'submit',
      function (event) {
        var mainForm = event.target.closest('.product-single__form');
        if (!mainForm) return;

        var pairedItems = collectPairedItems();
        if (!pairedItems.length) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var addBtn = mainForm.querySelector('[data-add-to-cart]');
        if (addBtn) addBtn.classList.add('btn--loading');

        var mainItem = buildMainItem(mainForm);
        var items = [mainItem].concat(pairedItems);
        items = maybeAppendCustomDateCharge(items, mainItem.properties);

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (error) {
                throw error;
              });
            }
            return response.json();
          })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function (error) {
            console.error('Main + complementary add error:', error);
          })
          .finally(function () {
            if (addBtn) addBtn.classList.remove('btn--loading');
          });
      },
      true
    );
  }

  function initBuyItWithDesktopFlickity() {
    var sliders = document.querySelectorAll('[data-buy-it-with-slider]');

    sliders.forEach(function (slider) {
      var isDesktop = window.innerWidth >= 750;

      if (typeof Flickity === 'undefined') {
        console.warn('Flickity is not loaded.');
        return;
      }

      var flickityInstance = Flickity.data(slider);

      if (!isDesktop) {
        if (flickityInstance) {
          flickityInstance.destroy();
        }

        slider.dataset.flickityReady = 'false';
        return;
      }

      if (slider.dataset.flickityReady === 'true') return;

      slider.dataset.flickityReady = 'true';

      new Flickity(slider, {
        cellAlign: 'left',
        contain: true,
        draggable: true,
        wrapAround: false,
        pageDots: false,
        prevNextButtons: true,
        imagesLoaded: true,
        groupCells: false
      });
    });
  }

  function initBuyItWithAjaxCart() {
    var forms = document.querySelectorAll('[data-paired-product-form]');

    forms.forEach(function (form) {
      if (form.dataset.qtyReady === 'true') return;
      form.dataset.qtyReady = 'true';

      var addBtn = form.querySelector('[data-paired-add-btn]');
      var qtyWrapper = form.querySelector('[data-paired-qty-wrapper]');
      var minusBtn = form.querySelector('[data-paired-minus]');
      var plusBtn = form.querySelector('[data-paired-plus]');
      var qtyText = form.querySelector('[data-paired-qty]');
      var qtyInput = form.querySelector('[data-paired-quantity-input]');

      if (!addBtn || !qtyWrapper || !minusBtn || !plusBtn || !qtyText || !qtyInput) return;

      function updateQty(qty) {
        qty = Math.max(0, qty);
        qtyText.textContent = qty;
        qtyInput.value = qty;

        if (qty === 0) {
          addBtn.style.display = '';
          qtyWrapper.style.display = 'none';
        } else {
          addBtn.style.display = 'none';
          qtyWrapper.style.display = 'inline-flex';
        }
      }

      addBtn.addEventListener('click', function () {
        if (document.body.classList.contains('template-cart')) return;
        updateQty(1);
      });

      plusBtn.addEventListener('click', function () {
        updateQty(Number(qtyInput.value || 0) + 1);
      });

      minusBtn.addEventListener('click', function () {
        updateQty(Number(qtyInput.value || 0) - 1);
      });
    });
  }

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-paired-add-btn]');
    if (!btn || document.querySelector('.product-single__form')) return;

    const form = btn.closest('[data-paired-product-form]');
    const variantId = form?.querySelector('input[name="id"]')?.value;
    if (!variantId) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    btn.disabled = true;
    const prevText = btn.textContent;
    btn.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });

      if (!res.ok) throw new Error('Add failed');

      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      btn.textContent = 'Added';
    } catch (err) {
      btn.disabled = false;
      btn.textContent = prevText;
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    initBuyItWithDesktopFlickity();
    initBuyItWithAjaxCart();
  });

  document.addEventListener('shopify:section:load', function () {
    initBuyItWithDesktopFlickity();
    initBuyItWithAjaxCart();
  });

  window.addEventListener('resize', function () {
    initBuyItWithDesktopFlickity();
  });
})();
